module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-riben.2ad738ab.jpg";